import { COMPANY_TYPES } from '../../utils/common'

export const PANELS = {
  COMPANY_OVERVIEW: 'COMPANY_OVERVIEW',
  OWNERSHIP_AND_GROUP: 'OWNERSHIP_AND_GROUP',
  KEY_FINANCIALS: 'KEY_FINANCIALS',
  SCORE: 'SCORE',
  RECENT_NEWS: 'RECENT_NEWS',
  COMPANY_ALERTS: 'COMPANY_ALERTS',
  TOP_INDUSTRY_PLAYERS: 'TOP_INDUSTRY_PLAYERS',
  TOP_COMPARABLE_PLAYERS: 'TOP_COMPARABLE_PLAYERS',
  FILING_STATUS: 'FILING_STATUS',
}

export const getPanelLink = (COMPONENTS, panelId) => {
  return {
    COMPANY_OVERVIEW:
      COMPONENTS.companyAnalysis.components.companyProfile.route,
    OWNERSHIP_AND_GROUP:
      COMPONENTS.companyAnalysis.components.ownershipAndGroup.route,
    KEY_FINANCIALS:
      COMPONENTS.companyAnalysis.components.financial.components
        .financialAnalysis.route,
    SCORE:
      COMPONENTS.companyAnalysis.components.score.components.corporateRiskScore
        .route,
    RECENT_NEWS: COMPONENTS.companyAnalysis.components.newsAndSocials.route,
    COMPANY_ALERTS: COMPONENTS.alerts.route,
    TOP_INDUSTRY_PLAYERS:
      COMPONENTS.companyAnalysis.components.industry.components.industryOverview
        .route,
    TOP_COMPARABLE_PLAYERS:
      COMPONENTS.companyAnalysis.components.industry.components.industryOverview
        .route,
    FILING_STATUS: COMPONENTS.companyAnalysis.components.filingStatus.route,
  }[panelId]
}

export const companyTypes = [
  COMPANY_TYPES.CORPORATE,
  COMPANY_TYPES.BANK,
  COMPANY_TYPES.SECURITIES,
  COMPANY_TYPES.NON_BANK,
  COMPANY_TYPES.FUNDS,
  COMPANY_TYPES.INSURANCE,
]
